import { RoofId } from "../constants/roofId";
import type { RoofV2 as Roof } from "../types/roof";

const getRoofBasedAccessories = (
  roof: Roof
): {
  ridgeStartCount: number;
  ridgeEndCount: number;
  yRidgeCount: number;
  hipStartCount: number;
} => {
  switch (roof.id) {
    case RoofId.Roof1:
    case RoofId.Roof5: {
      return {
        ridgeStartCount: 1,
        ridgeEndCount: 1,
        yRidgeCount: 0,
        hipStartCount: 0
      };
    }
    case RoofId.Roof2:
    case RoofId.Roof3:
    case RoofId.Roof6: {
      return {
        ridgeStartCount: 2,
        ridgeEndCount: 1,
        yRidgeCount: 0,
        hipStartCount: 0
      };
    }
    case RoofId.Roof4: {
      return {
        ridgeStartCount: 2,
        ridgeEndCount: 0,
        yRidgeCount: 1,
        hipStartCount: 1
      };
    }
    case RoofId.Roof7: {
      return {
        ridgeStartCount: 0,
        ridgeEndCount: 0,
        yRidgeCount: 2,
        hipStartCount: 4
      };
    }
    case RoofId.Roof8: {
      return {
        ridgeStartCount: 1,
        ridgeEndCount: 0,
        yRidgeCount: 2,
        hipStartCount: 4
      };
    }
    case RoofId.Roof9: {
      return {
        ridgeStartCount: 0,
        ridgeEndCount: 0,
        yRidgeCount: 3,
        hipStartCount: 6
      };
    }
    default: {
      return {
        ridgeStartCount: 0,
        ridgeEndCount: 0,
        yRidgeCount: 0,
        hipStartCount: 0
      };
    }
  }
};

export default getRoofBasedAccessories;
